import { ADMIN } from '@/common/constants/userTypes';

// Раздел «Клиенты» у админа: вкладки-уровни поверх старых роутов (старые ссылки продолжают работать).
export const CLIENTS_SECTION_TABS = [
  { title: 'Корп. клиенты', to: 'clients', permission: ['bookmark_corporate_clients'] },
  { title: 'Менеджеры', to: 'managers', permission: ['bookmark_managers'] },
  { title: 'Кандидаты', to: 'candidates', permission: ['bookmark_candidates'] },
  { title: 'Администраторы', to: 'admins', permission: ['bookmark_administrators'] },
];

// Видит ли пользователь раздел «Клиенты» с вкладками: только админ и только если доступно больше одной вкладки.
export function allowedClientsSectionTabs(store) {
  const user = store.getters['auth/user'];
  if (!user || user.user_type !== ADMIN) return [];
  const tabs = CLIENTS_SECTION_TABS.filter((tab) => store.getters['auth/isAllowed'](tab.permission));
  return tabs.length > 1 ? tabs : [];
}

// Пути, на которых пункт меню «Клиенты» подсвечен (списки и карточки).
export const CLIENTS_SECTION_PATHS = ['/clients', '/managers', '/candidates', '/admins'];

// Порядок пунктов меню админа (по прототипу). Пункты, которых здесь нет, идут следом в прежнем порядке.
export const ADMIN_MENU_ORDER = [
  'clients-section',
  'list-services',
  'orders',
  'analitics',
  'partners',
  'reports',
  'profgrams',
  'diagnostic',
  'booking-calendar',
  'ai',
  'admin-panel',
  'edit-tests',
  'access',
  'support',
];
